module.exports = __webpack_public_path__ + "img/one.8fbbcc4c.png";